export enum NotificationType {
  NEW_ARTICLE,
  NEW_EVENT,
  YOUR_COMMENT_REPLY,
  COMMENT_REPLY,
  NEW_COMMENT,
  NEW_QUIZ,
  NEW_SURVEY,
}
